import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {GameComponent} from "./game/game.component";
import {PageComponent} from "./page/page.component";


const routes: Routes = [
  {
    path: '',
    component: PageComponent,
    data: { title: 'He', path: 'coming-soon', nav: true }
  },
  {
    path: 'play',
    component: GameComponent,
    data: { title: 'Play', path: 'play', nav: true },
  },
  // {
  //   path: 'register',
  //   component: GameComponent,
  //   data: { path: 'register' }
  // },
  // {
  //   path: 'login',
  //   component: GameComponent,
  //   data: { path: 'login' }
  // },
  // {
  //   path: 'invite',
  //   component: GameComponent,
  //   data: { path: 'invite' }
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
